module.exports = __webpack_public_path__ + "fonts/roboto-bold.5e9f655.ttf";